import { TASK_STATUS, dueSoon, isOverdue, sinceLabel } from "../../lib/domain.js";

/* This week's tasks. A committed date that has passed is the thing the
   board exists to surface, so overdue is drawn on the row itself and not
   only counted on the tile. */
export function TaskRows({ tasks, onChange, onNotify, mailEnabled }) {
  if (!tasks.length) return <p className="empty">No tasks this week.</p>;

  const set = (i, field, value) => {
    onChange(tasks.map((t, j) => (j === i ? { ...t, [field]: value } : t)));
  };

  return (
    <div className="rows">
      {tasks.map((t, i) => {
        const over = isOverdue(t);
        const soon = dueSoon(t);
        const cls =
          TASK_STATUS[t.status].cls + (t.critical ? " crit" : "") + (over ? " over" : "");

        let flag = null;
        if (t.status === "done") flag = null;
        else if (over) flag = <span className="pend bad">Overdue</span>;
        else if (soon) flag = <span className="pend">Due {t.due}</span>;
        else flag = <span className="pend">Pending</span>;

        return (
          <div className={"task " + cls} key={i}>
            {/* The card's two controls share a row above the fields, which
                are full width and wrap one to a line: the flag on the left
                where it was, the delete on the right. */}
            <div className="delrow">
              <button
                className="btn-icon flag"
                type="button"
                aria-pressed={Boolean(t.critical)}
                title="Mark as a critical action"
                aria-label="Mark as a critical action"
                onClick={() => set(i, "critical", !t.critical)}
              >
                !
              </button>
              <button
                className="btn-icon del"
                type="button"
                aria-label="Delete task"
                onClick={() => onChange(tasks.filter((_, j) => j !== i))}
              >
                &#10005;
              </button>
            </div>
            <input
              className="in grow"
              value={t.title}
              placeholder="Task"
              aria-label={"Task " + (i + 1) + " title"}
              onChange={(e) => set(i, "title", e.target.value)}
            />
            <div className="meta">
              <input
                className="in fix"
                value={t.assignee}
                placeholder="Who"
                aria-label="Assignee"
                onChange={(e) => set(i, "assignee", e.target.value)}
              />
              <select
                className="in fix"
                value={t.status}
                aria-label="Status"
                onChange={(e) => set(i, "status", e.target.value)}
              >
                {Object.entries(TASK_STATUS).map(([k, v]) => (
                  <option key={k} value={k}>
                    {v.label}
                  </option>
                ))}
              </select>
              <input
                type="date"
                className="in dt"
                value={t.due}
                title="Committed date"
                aria-label="Committed date"
                onChange={(e) => set(i, "due", e.target.value)}
              />
              <span className="wk">{t.week}</span>
              {flag}
              {mailEnabled && t.status !== "done" && (
                <button
                  className="btn btn-sm notify"
                  type="button"
                  onClick={() => onNotify(i)}
                >
                  Notify
                </button>
              )}
              {t.notifiedAt && <span className="wk sent">{sinceLabel(t.notifiedAt)}</span>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
